import React from 'react';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Core components
import Typography from 'components/core/Typography';
// Hocs
import withScroll from 'hocs/WithScroll';

const FormHelperContent = withScroll(({ elements }) => (
  <div className="mr-3" style={{ marginTop: -12 }}>
    {_map(elements, ({ title, content }, index) => (
      <div key={index} style={{ paddingTop: 12 }}>
        {title && (
          <Typography type="formHelperTitle">
            {title}
          </Typography>
        )}
        <div className="pt-2">
          {content}
        </div>
      </div>
    ))}

  </div>
), { autoHide: false });

FormHelperContent.propTypes = {
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
      ]),
      content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
      ]).isRequired,
    }),
  ).isRequired,
};

/* eslint-disable react/jsx-props-no-spreading */
const FormHelper = (props) => (
  <div style={{ width: 380 }} className="hidden-sm-down pt-2 pr-1 text-justify">
    <FormHelperContent {...props} />
  </div>
);
/* eslint-enable react/jsx-props-no-spreading */

module.exports = FormHelper;



// WEBPACK FOOTER //
// ./components/misc/FormHelper.js